import { useEffect, useState } from "react";
import { getSettings, DEFAULT_SETTINGS } from "lib/settings";

/**
 * Shared read hook for contact/business details. Starts from
 * DEFAULT_SETTINGS so the footer/contact page never flash empty while the
 * real values load.
 */
export function useSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    getSettings()
      .then((data) => {
        if (isMounted) setSettings(data);
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return { settings, isLoading };
}
